"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const constants_1 = require("components/cosmos/toast/constants");
const Survicate_1 = require("configs/Survicate");
const translationContext_1 = require("configs/translationContext");
const clubWebSocket_1 = require("helpers/clubWebSocket");
const services_1 = require("modules/app/services");
const dripping_1 = require("modules/app/services/datahub/dripping");
const useDatahubBaseEvent_1 = __importDefault(require("modules/app/services/datahub/useDatahubBaseEvent"));
const viewBulkDrippingCreateSchema_1 = __importDefault(require("modules/app/services/datahubEvents/module/viewBulkDrippingCreateSchema"));
const ModuleEditorParamsUtils_1 = __importDefault(require("modules/content/moduleEditor/ModuleEditorParamsUtils"));
const ui_1 = require("modules/ui");
const bulkDrippingFeedback_1 = __importDefault(require("./bulkDrippingFeedback"));
const drippingForm_1 = __importDefault(require("./drippingForm"));
const reviewDrippingModal_1 = __importDefault(require("./reviewDrippingModal"));
const useBulkRequest_1 = __importDefault(require("../hooks/useBulkRequest"));
const useBulkWizardActionsContext_1 = __importDefault(require("../hooks/useBulkWizardActionsContext"));
const drippingService_1 = __importDefault(require("../services/drippingService"));
const stores_1 = require("../stores");
const types_1 = require("../types");
var BulkNewDrippingSteps;
(function (BulkNewDrippingSteps) {
    BulkNewDrippingSteps[BulkNewDrippingSteps["FillForm"] = 1] = "FillForm";
    BulkNewDrippingSteps[BulkNewDrippingSteps["Review"] = 2] = "Review";
    BulkNewDrippingSteps[BulkNewDrippingSteps["Processing"] = 3] = "Processing";
})(BulkNewDrippingSteps || (BulkNewDrippingSteps = {}));
const BulkNewDrippingStepper = () => {
    const { t } = (0, translationContext_1.useTranslation)();
    const [currentStep, setCurrentStep] = (0, react_1.useState)(BulkNewDrippingSteps.FillForm);
    const [dripping, setDripping] = (0, react_1.useState)(null);
    const [callbackContextId] = (0, react_1.useState)(clubWebSocket_1.ClubWebSocketUtil.generateContextId());
    const { modules, pages, onProcessFinish } = (0, useBulkWizardActionsContext_1.default)();
    const { captureException } = (0, useBulkRequest_1.default)();
    const baseEvent = (0, useDatahubBaseEvent_1.default)();
    const handleCloseForm = () => {
        setDripping(null);
        stores_1.BulkDrippingStore.resetAction();
        dripping_1.DatahubBulkDrippingService.sendCancelNewBulk({
            ...baseEvent,
            numberOfModulesSelected: modules.length,
            numberOfPagesSelected: pages.length
        });
    };
    const handleSaveForm = (newDripping) => {
        setDripping(newDripping);
        setCurrentStep(BulkNewDrippingSteps.Review);
    };
    const handleCancelReview = () => {
        setDripping(null);
        stores_1.BulkDrippingStore.resetAction();
    };
    const handleBackReview = () => {
        setCurrentStep(BulkNewDrippingSteps.FillForm);
    };
    const handleConfirmReview = async () => {
        if (dripping) {
            const payload = {
                callbackContextId,
                drippingConfig: {
                    classes: dripping.classes.map(({ hashId }) => hashId)
                },
                modules,
                pages
            };
            if (dripping.releaseDate) {
                payload.drippingConfig.liberation = {
                    type: types_1.DrippingLiberationTypes.Date,
                    liberationDate: dripping.releaseDate
                };
            }
            else if (dripping.releaseDays) {
                payload.drippingConfig.liberation = {
                    type: types_1.DrippingLiberationTypes.Days,
                    liberationDays: dripping.releaseDays
                };
            }
            else if (dripping.pageId) {
                payload.drippingConfig.liberation = {
                    type: types_1.DrippingLiberationTypes.Quiz,
                    pageId: dripping.pageId
                };
            }
            if (dripping.expirationDays) {
                payload.drippingConfig.expiration = {
                    type: 'BY_DAYS',
                    durationDays: dripping.expirationDays
                };
            }
            const onSuccess = async () => {
                await drippingService_1.default.postDrippingBulk(payload);
                setCurrentStep(BulkNewDrippingSteps.Processing);
                const { expiration, liberation } = payload.drippingConfig;
                dripping_1.DatahubBulkDrippingService.sendNewBulkEvent({
                    ...baseEvent,
                    bulkId: callbackContextId,
                    isAllClasses: dripping.allClasses,
                    liberationDays: (liberation === null || liberation === void 0 ? void 0 : liberation.type) === types_1.DrippingLiberationTypes.Days
                        ? liberation.liberationDays
                        : void 0,
                    liberationDate: (liberation === null || liberation === void 0 ? void 0 : liberation.type) === types_1.DrippingLiberationTypes.Date
                        ? liberation.liberationDate
                        : void 0,
                    expirationDays: expiration === null || expiration === void 0 ? void 0 : expiration.durationDays,
                    isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam(),
                    numberOfModulesSelected: modules.length,
                    numberOfPagesSelected: pages.length
                });
                services_1.DatahubEventsService.sendEvent({
                    schema: new viewBulkDrippingCreateSchema_1.default({
                        arrivedFrom: services_1.ArrivedFrom.CONTENT_LIST
                    })
                });
            };
            await captureException({ onSuccess });
            (0, Survicate_1.invokeEvent)(Survicate_1.SURVEY_EVENTS.BULK_DRIPPING_BY_CLASS);
        }
    };
    const handleFinish = () => {
        setDripping(null);
        onProcessFinish === null || onProcessFinish === void 0 ? void 0 : onProcessFinish();
        stores_1.BulkDrippingStore.resetAction();
        stores_1.BulkDrippingStore.setActionInProgress(false);
    };
    const sendNewBulkProcessEvent = ({ total, completed }) => {
        if (dripping) {
            dripping_1.DatahubBulkDrippingService.sendNewBulkProcessEvent({
                ...baseEvent,
                isExtraModule: ModuleEditorParamsUtils_1.default.getExtraParam(),
                parentBulkId: callbackContextId,
                isAllClasses: dripping.allClasses,
                ...(dripping.releaseDays && { liberationDays: dripping.releaseDays }),
                ...(dripping.releaseDate && { liberationDate: dripping.releaseDate }),
                ...(dripping.expirationDays && {
                    expirationDays: dripping.expirationDays
                }),
                numberOfItems: total,
                numberOfItemsProcessed: completed,
                processingTimeInSeconds: stores_1.BulkDrippingStore.getBulkProcessTimeInSeconds()
            });
        }
    };
    const handleDone = (statusMessage) => {
        sendNewBulkProcessEvent(statusMessage);
        handleFinish();
        ui_1.UiService.setAlertWithText({
            message: t('dripping_2.notifications.create_success'),
            type: constants_1.TOAST_TYPE.success
        });
    };
    const handlePartiallyDone = (statusMessage) => {
        sendNewBulkProcessEvent(statusMessage);
        handleFinish();
        ui_1.UiService.setAlertWithText({
            message: t('dripping_2.notifications.create_error'),
            type: constants_1.TOAST_TYPE.danger
        });
    };
    const renderComponentByStep = () => {
        const STEP_COMPONENTS = {
            [BulkNewDrippingSteps.FillForm]: ((0, jsx_runtime_1.jsx)(drippingForm_1.default, { isBulkOperation: true, dripping: dripping, onClose: handleCloseForm, onSave: handleSaveForm })),
            [BulkNewDrippingSteps.Review]: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: dripping && ((0, jsx_runtime_1.jsx)(reviewDrippingModal_1.default, { dripping: dripping, onCancel: handleCancelReview, onBack: handleBackReview, onConfirm: handleConfirmReview })) })),
            [BulkNewDrippingSteps.Processing]: ((0, jsx_runtime_1.jsx)(bulkDrippingFeedback_1.default, { title: t('dripping_2.bulk_action.report.create_title'), contextId: callbackContextId, onDone: handleDone, onPartiallyDone: handlePartiallyDone, onError: handleFinish }))
        };
        return STEP_COMPONENTS[currentStep];
    };
    return renderComponentByStep();
};
exports.default = BulkNewDrippingStepper;
